// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"b8fc0cc6","729":"cf8e2bdb"}[chunkId] + ".css";
};